<template>
  <div class="SelectBoxArea">
    <p class="label">{{ text }}</p>
    <SelectBox
      :item-list="itemList"
      :initialValue="initialValue"
      @change-value="changeValue"
    />
  </div>
</template>

<script>
import SelectBox from "@/components/Atoms/SelectBox";

export default {
  name: "select-box",
  components: {
    SelectBox,
  },
  props: {
    text: { type: String, required: true },
    itemList: { type: Array, required: true },
    initialValue: {
      type: String,
      required: false,
    },
  },
  methods: {
    changeValue(e) {
      this.$emit("change-value", e);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.SelectBoxArea {
  /* border-top: 1px #e7e7e7 solid; */
  margin: 0;
  padding-bottom: 1rem;
  .label {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin: 0.5rem 0;
    &::before {
      content: "";
      background: #5cd5d6;
      width: 3px;
      height: calc(1rem + 0.1rem);
      margin-right: 0.25rem;
      display: inline-block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Atoms/SelectBoxArea.vue